const enabled = process.env.REACT_APP_JOURNEY_COLLECTIONS === 'true';

// Lista de OPL (logisticOperatorID) separados por coma. Vacía: todos los OPL.
const operators = (process.env.REACT_APP_JOURNEY_COLLECTIONS_OPERATORS || '')
  .split(',')
  .map((id) => Number(id.trim()))
  .filter((id) => Number.isInteger(id) && id > 0);

// Colectas en rutas: el flag enciende la feature y la lista de OPL la limita a esos
// operadores. Así producción la ve solo el piloto y el resto sigue como hoy.
export const collectionsEnabledFor = (logisticOperatorID) =>
  enabled &&
  (operators.length === 0 || operators.includes(Number(logisticOperatorID)));

export default { collectionsEnabledFor };
